import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent {
  @Input() bsClass: 'primary' | 'success' | 'default' | 'info' = 'default';
  @Input() showLoader = false;
  @Input() buttonType: 'button' | 'submit' = 'button';
  @Input() disabled = false;
  @Input() tooltip = '';
  @Input() labeled = false;
  @Output() handleClick: EventEmitter<void> = new EventEmitter<void>();
}
